import React, { Component } from 'react';

class PageSet extends Component {
  constructor(props){
    super();
    this.state ={
      name:"",
      isShowInput:false,
      inputValue:"",
    }
    document.title = "设置";
  }
  switchInputPopup=()=>{
    this.setState({
      isShowInput: !this.state.isShowInput
    })
  }
  gomanual=()=>{
    this.props.history.push('/mcommonchat/manual');
  }
  handleChange=(event)=>{
    this.setState({
      inputValue: event.target.value
    })
  }
  handleKeyUp=(event)=>{
    console.log("keyup",event.keyCode);
    let val = event.target.value;
    val.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "");
    let _this = this;
     if(event.keyCode === 13){
         //actions.inputAreaData.changeInputValue({data:""});
         //document.querySelector('#userinput').blur();
        fetch("//zpchatbot.58.com/saveChatName",{
          method:"POST",
          mode: 'cors',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
          },
          body:"nickname="+encodeURI(encodeURI(val))
        })
        .then(function(data){
          return data.json();
        })
        .then(function(data) {
          console.log(data)
          if(data.code<=0){
            alert("啊哦，出错了，再试试吧")
          }else{
            _this.setState({
              name:val,
              inputValue:"",
              isShowInput:false,
            })
          }
      }).catch(function(){
        alert("啊哦，出错了，再试试吧")
      })
     }
 }
 confirmName=()=>{
  //临时加 后续优化
  let val = this.state.inputValue;
  val.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "");
  let _this = this;
  fetch("//zpchatbot.58.com/saveChatName",{
    method:"POST",
    mode: 'cors',
    credentials: 'include',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    body:"nickname="+encodeURI(encodeURI(val))
  })
  .then(function(data){
    return data.json();
  })
  .then(function(data) {
    if(data.code<=0){
      alert("啊哦，出错了，再试试吧")
    }else{
      _this.setState({
        name:val,
        inputValue:"",
        isShowInput:false,
      })
    }
}).catch(function(){
  alert("啊哦，出错了，再试试吧")
})
 }
  componentDidMount(){
    //接口获取名字
    let url = "//zpchatbot.58.com/getChatName";
    let _this = this;
    fetch(url,{
      mode: 'cors',
      credentials: 'include',
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
      },
    })
    .then(function(response) {
      return response.json()
    }).then(function(data) {
        //data = JSON.parse(data);
        if(data.code==1){
          _this.setState({
            name:data.nickname
          })
        }else{
          _this.setState({
            name:""
          })
        }
    }).catch(function(){
      _this.setState({
        name:""
      })
    })
  }
  render() {
    const {name,inputValue,isShowInput}= this.state;
    return (
      <div className="robotchat-set-ui" id="robotchat-set-ui">
        <div className="item-wrap">
          <div className="list-item" onClick={this.switchInputPopup}>
            <span className="maintxt">呼唤我的名字</span>
            <span className="subtxt">{name==""?"想要小聘怎么呼唤您":""}</span>
            <span className="maintxt right">{name}</span>
            <i className="iconfont icon-click_guideblack_ic arrow-right"></i>
          </div>
          <div className="list-item" onClick={this.gomanual}>
            <span className="maintxt">小聘使用指南</span>
            <i className="iconfont icon-click_guideblack_ic arrow-right"></i>
          </div>
        </div>
        {
          isShowInput?
          <div className="input-popup">
            <div className="masker"></div>
            <div className="input-wrap">
              <div className="title">呼唤我的名字</div>
              <input placeholder="例：主人" value={inputValue} type="text" maxLength="10" onChange={this.handleChange} onKeyUp={this.handleKeyUp}></input>
              <div className="close-btn iconfont icon-close_icx" onClick={this.switchInputPopup}></div>
              <div className="confirm-btn" onClick={this.confirmName}>确定</div>
            </div>
        </div>:null
        }

      </div>
    );
  }
}

export default PageSet;

/**
 * 
 * state
 * {
 *  
 *  chatAreaRenderData:[{
 *    isFetching:true,
 *    input:{
 *      txt:"hello",
 *      isShow:true
 *    },
 *    reply:{
 *      data:[{type:-1},{}],
 *      isShow:true,
 *    }
 * }]
 *  inputData:{
 *    val:'lalal'
 * }
 * }
 */

